import React from "react";
import { Badge } from "../Badge";

type CardImageProps = {
	imageSrc: string;
	imageStatus?: boolean;
	completed?: boolean;
	onClick?: (val?: any) => {};
};

export default function CardImage({
	imageSrc,
	imageStatus,
	completed = false,
	onClick,
}: CardImageProps) {
	return (
		<div className="w-[100%] h-[15rem] max-h-[20rem] relative">
			<img
				src={imageSrc}
				content="contain"
				className="w-full h-full block object-cover hover:cursor-pointer rounded-t-lg"
                onClick={()=>onClick}
			/>
			<div className="absolute top-3 right-3">
				<Badge
					label={completed ? "Completed": (imageStatus ? "Active" : "Inactive")}
					variant={completed ? "success" : (imageStatus ? "success" : "error")}
				/>
			</div>
		</div>
	);
}
